module.exports = __webpack_public_path__ + "static/media/app-bar-save.e462b28c.svg";